/**
 * defa.views.ControlApplicationInstallView
 * The view for informing the user of our native applications.
 * @version 1.2.0
 */
import View     from 'scripts/poppet/view';
import template from 'templates/applicationInstallView.jst.html';


const ControlApplicationInstallView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default ControlApplicationInstallView;